import axios from 'axios'
import SignOut from '../components/SignIn/SignOut'
const store = require('store')

const getScanFile = async () => {
	const getScanFileList_api = '/scanner/file'
	let result
	try {
		let headers = {
			Authorization: 'Bearer ' + store.get('access_token'),
			site: store.get('site'),
			locale: store.get('locale'),
		}
		console.log(process.env.REACT_APP_API_URL_3018 + getScanFileList_api)
		result = await axios({
			method: 'get',
			url: process.env.REACT_APP_API_URL_3018 + getScanFileList_api,
			headers: headers,
		})

		return result.data
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			} else {
				throw new Error(error)
			}
		} catch (error) {
			throw new Error(error)
		}
	}
}

const cancelScanFile = async (scan_file_seq) => {
	const postCancelScanFile_api = '/scanner/file/'+scan_file_seq
	let headers
	let params = new URLSearchParams()
	let result

	try {
		headers = {
			Authorization: 'Bearer ' + store.get('access_token'),
			site: store.get('site'),
			locale: store.get('locale'),
		}


		result = await axios({
			method: 'delete',
			url: process.env.REACT_APP_API_URL_3018 + postCancelScanFile_api,
			headers: headers
		})

		return result.data
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			} else {
				throw new Error(error)
			}
		} catch (error) {
			throw new Error(error)
		}
	}
}

const downloadScanFile = async (scan_file_seq) => {
	const getDownloadScanFile_api = '/file/download'
	let headers
	let queryParams

	try {
		headers = {
			Authorization: 'Bearer ' + store.get('access_token'),
			site: store.get('site'),
			locale: store.get('locale'),
		}

		const response = await axios({
			method: 'get',
			url:
				process.env.REACT_APP_API_URL_3002 +
				getDownloadScanFile_api +
				'?file_ref=' +
				scan_file_seq +
				'&file_cat=scanner',
			headers: headers,
			responseType: 'blob',
		})

		const blob = new Blob([response.data], { type: response.data.type })
		const downloadUrl = window.URL.createObjectURL(blob)
		const link = document.createElement('a')
		link.href = downloadUrl
		const header_filename = response.headers['download-filename']
		let filename = 'date_time'
		if (header_filename) {
			filename = decodeURIComponent(header_filename);
		}
		link.setAttribute('download', filename)
		document.body.appendChild(link)
		link.click()
		link.remove()
	} catch (error) {
		try {
			if (error.response.status === 401) {
				// DoRefreshToken()
				SignOut()
			} else {
				throw new Error(error)
			}
		} catch (error) {
			throw new Error(error)
		}
	}
}
export { getScanFile, cancelScanFile, downloadScanFile}
